import data from "../../../../../src/ToggleSwitch/ToggleSwitch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};